import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Preloader.css';

const Preloader = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        // Smooth progress counter
        const duration = 3000; // 3 seconds total
        const interval = 30;
        const steps = duration / interval;
        let step = 0;

        const progressTimer = setInterval(() => {
            step++;
            // Ease-out curve for natural feel
            const t = step / steps;
            const eased = 1 - Math.pow(1 - t, 3);
            setProgress(Math.min(Math.round(eased * 100), 100));

            if (step >= steps) {
                clearInterval(progressTimer);
                setTimeout(() => setIsLoading(false), 400);
            }
        }, interval);

        return () => clearInterval(progressTimer);
    }, []);

    // Letter animation for "DEPLOY-X"
    const brandName = "DEPLOY-X";
    const letterVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: 0.3 + i * 0.08,
                duration: 0.5,
                ease: [0.25, 1, 0.5, 1]
            }
        })
    };

    return (
        <AnimatePresence>
            {isLoading && (
                <motion.div
                    className="preloader-screen"
                    initial={{ opacity: 1 }}
                    exit={{ opacity: 0, scale: 1.05 }}
                    transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
                >
                    {/* Ambient glow */}
                    <div className="preloader-ambient"></div>

                    <div className="preloader-center">
                        {/* Animated brand letters */}
                        <div className="preloader-brand">
                            {brandName.split('').map((char, i) => (
                                <motion.span
                                    key={i}
                                    className={`preloader-letter ${char === '-' ? 'preloader-dash' : ''}`}
                                    custom={i}
                                    initial="hidden"
                                    animate="visible"
                                    variants={letterVariants}
                                >
                                    {char}
                                </motion.span>
                            ))}
                        </div>

                        {/* Tagline */}
                        <motion.p
                            className="preloader-tagline"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 1.2, duration: 0.8 }}
                        >
                            Engineering Digital Excellence
                        </motion.p>

                        {/* Progress bar */}
                        <div className="preloader-progress-track">
                            <motion.div
                                className="preloader-progress-fill"
                                initial={{ width: '0%' }}
                                animate={{ width: '100%' }}
                                transition={{ duration: 3, ease: [0.25, 1, 0.5, 1] }}
                            />
                        </div>

                        {/* Percentage */}
                        <motion.span
                            className="preloader-percent"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.5, duration: 0.4 }}
                        >
                            {progress}%
                        </motion.span>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default Preloader;
